import { useState, useEffect } from 'react';
import { networkService } from '../components/config/axios';
import { getCookie, setCookie } from './helper';

const useRecipientNotification = (editEnabled, pageNumber, tlb, notificationURL = null) => {
  const [isApiCalled, setIsApiCalled] = useState(() => {
    // Persist across refreshes via cookie — same guard as production's notifySentCookie
    const sent = getCookie("notifySent", []);
    return Array.isArray(sent) && sent.includes(tlb?.token);
  });

  useEffect(() => {
    if (editEnabled || isApiCalled) return;
    if (tlb?.send_engagement_notif == true && tlb?.notify_after != '') {
      const timer = setTimeout(() => {
        myApiCall();
      }, tlb.notify_after * 1000);
      return () => clearTimeout(timer);
    } else if (tlb?.send_engagement_notif == true && pageNumber != null && pageNumber === tlb?.notify_for_page) {
      const timer = setTimeout(() => {
        myApiCall();
      }, tlb.notify_page_after * 1000);
      return () => clearTimeout(timer);
    }
  }, [pageNumber, tlb, isApiCalled]);

  const myApiCall = async () => {
    if (notificationURL != null) {
      await networkService(notificationURL);
    }
    // Mark sent in cookie so refresh doesn't re-fire (mirrors production notifySentCookie)
    const sent = getCookie("notifySent", []);
    if (Array.isArray(sent) && !sent.includes(tlb?.token)) {
      sent.push(tlb?.token);
      setCookie("notifySent", sent);
    }
    setIsApiCalled(true);
  };
};

const usePageNumber = (initialPage = 1) => {
  const [pageNumber, setPageNumber] = useState(initialPage);

  const nextPage = () => setPageNumber(prev => prev + 1);
  const prevPage = () => setPageNumber(prev => Math.max(1, prev - 1));

  return { pageNumber, nextPage, prevPage };
};

export { useRecipientNotification, usePageNumber };
